
export const ESTADOS_ENCOMIENDA = ["Recibido", "Entregado"];

export const MAX_FOTOS = 6;

export const rutaColeccionEncomiendas = (nit, year, mes) =>
  `coordi_ph/${nit}/domicilios/${year}/${mes}`;

export const rutaEncomienda = (nit, year, mes, id) =>
  `${rutaColeccionEncomiendas(nit, year, mes)}/${id}`;

export const viviendaNotificacion = (vivienda) =>
  (vivienda || "")
    .toString()
    .toLowerCase()
    .replaceAll("  ", "")
    .replaceAll(" ", "")
    .replaceAll("-", "")
    .replaceAll("#", "");

export const viviendaCorreo = (vivienda) =>
  (vivienda || "").toString().toLowerCase().replaceAll(" ", "");

export const nuevaEncomienda = (campos = {}) => ({
  id: null,
  fechaCreacion: null,
  vivienda: null,
  usuario: null,
  contador: null,
  descripcionDomicilio: null,
  estado: null,
  quienLoTrae: null,
  fecha_inicio_encomienda: null,
  hora_inicio_encomienda: null,
  url_encomienda_1: "",
  url_encomienda_2: "",
  url_encomienda_3: "",
  url_encomienda_4: "",
  url_encomienda_5: "",
  url_encomienda_6: "",
  descripcion_encomienda: null,
  correoNotificacion: null,
  nombre_completo_persona_recibe_paquete: null,
  url_firma_cliente: null,
  ...campos,
});


export const bitacoraCreacion = (usuario, fechaSolo) =>
  `Usuario: ${usuario}\nFecha: ${fechaSolo}\n\nSe crea paquete.`;

export const bitacoraGestion = (previo, usuario, fechaHora12) =>
  `${previo || ""}\n\nUsuario: ${usuario}\nFecha: ${fechaHora12}\n\n` +
  `Se accede a gestionar la encomienda como entregada.\n\n`;
